import { BUSINESS, SITE_URL, absoluteUrl } from "./siteConfig";

/**
 * Stable @id values. The GeneralContractor and WebSite nodes are emitted
 * statically in public/index.html so crawlers that do not run JavaScript still
 * see them; per-page schema below only references them by @id instead of
 * repeating the whole business record.
 */
export const ORG_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

type Crumb = { name: string; path: string };

export const breadcrumbSchema = (crumbs: Crumb[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((crumb, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: crumb.name,
    item: absoluteUrl(crumb.path),
  })),
});

export const serviceSchema = (opts: {
  name: string;
  description: string;
  path: string;
  image?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: opts.name,
  description: opts.description,
  url: absoluteUrl(opts.path),
  ...(opts.image ? { image: opts.image } : {}),
  serviceType: opts.name,
  provider: { "@id": ORG_ID },
  areaServed: [
    { "@type": "City", name: "Jhajjar" },
    { "@type": "City", name: "Rohtak" },
    { "@type": "AdministrativeArea", name: "Haryana" },
  ],
});

export const projectSchema = (opts: {
  name: string;
  description: string;
  path: string;
  image?: string;
  location?: string;
  startDate?: string;
  endDate?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "CreativeWork",
  name: opts.name,
  description: opts.description,
  url: absoluteUrl(opts.path),
  ...(opts.image ? { image: opts.image } : {}),
  ...(opts.location ? { contentLocation: { "@type": "Place", name: opts.location } } : {}),
  ...(opts.startDate ? { dateCreated: opts.startDate } : {}),
  ...(opts.endDate ? { datePublished: opts.endDate } : {}),
  creator: { "@id": ORG_ID },
});

export const contactPageSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ContactPage",
  url: absoluteUrl("/contact"),
  mainEntity: {
    "@id": ORG_ID,
    telephone: BUSINESS.phone,
    email: BUSINESS.email,
  },
});

export const aboutPageSchema = () => ({
  "@context": "https://schema.org",
  "@type": "AboutPage",
  url: absoluteUrl("/about"),
  mainEntity: { "@id": ORG_ID },
});
